@if (draft.open) {
  <div class="pc">
    <p class="pc-hint">Write your question in the box above, then add the choices.</p>

    @for (option of draft.options; track $index) {
      <div class="pc-row">
        <input
          type="text"
          class="pc-option"
          autocomplete="off"
          [attr.maxlength]="maxLength"
          [attr.aria-label]="'Poll option ' + ($index + 1)"
          [placeholder]="'Option ' + ($index + 1)"
          [value]="option"
          (input)="draft.setOption($index, $any($event.target).value)" />
        @if (draft.options.length > 2) {
          <button type="button" class="pc-remove" [attr.aria-label]="'Remove option ' + ($index + 1)" (click)="draft.removeOption($index)">
            &times;
          </button>
        }
      </div>
    }

    <div class="pc-foot">
      @if (draft.options.length < maxOptions) {
        <button type="button" class="pc-add" (click)="draft.addOption()"><i class="fa fa-plus"></i> Add option</button>
      }
      <label class="pc-duration">
        Ends in
        <ng-select class="wt-select" [(ngModel)]="draft.hours" [items]="durations" bindValue="hours" bindLabel="label"
          placeholder="No end" [clearable]="false" [searchable]="false" appendTo="body">
        </ng-select>
      </label>
    </div>

    @if (draft.hasDuplicates) {
      <p class="pc-error">Each option needs to be different.</p>
    }
  </div>
}
